/**
 * Style tokens shared by the web create-CV screen and its two step components.
 *
 * They used to live at the bottom of `create.web.tsx` alongside the steps
 * themselves, which is why that route file was three times the size of its
 * native twin. Tabbio web design system values; no logic.
 */
import type { CSSProperties } from 'react';

export const FIELD_LABEL: CSSProperties = {
  fontSize: 13,
  fontWeight: 500,
  color: 'var(--text-secondary)',
  marginBottom: 8,
  display: 'block',
};

export const INPUT_PILL: CSSProperties = {
  width: '100%',
  height: 52,
  borderRadius: 9999,
  border: '1px solid var(--input-border)',
  padding: '0 22px',
  fontSize: 15,
  color: 'var(--text-primary)',
  backgroundColor: 'var(--input-bg)',
  boxShadow: 'var(--gem-input-shadow)',
  fontFamily: 'inherit',
  outline: 'none',
  boxSizing: 'border-box',
};

export const TEXTAREA: CSSProperties = {
  width: '100%',
  minHeight: 140,
  borderRadius: 16,
  border: '1px solid var(--input-border)',
  padding: '14px 18px',
  fontSize: 15,
  lineHeight: '22px',
  color: 'var(--text-primary)',
  backgroundColor: 'var(--input-bg)',
  boxShadow: 'var(--gem-input-shadow)',
  fontFamily: 'inherit',
  outline: 'none',
  boxSizing: 'border-box',
  resize: 'vertical',
};

export const HINT: CSSProperties = {
  fontSize: 13,
  lineHeight: '18px',
  color: 'var(--text-tertiary)',
  margin: '6px 0 0',
};

export const RECAP: CSSProperties = {
  fontSize: 13.5,
  lineHeight: '19px',
  color: 'var(--text-secondary)',
  backgroundColor: 'rgba(0,0,0,0.04)',
  borderRadius: 16,
  padding: '12px 18px',
};

// A fixed slot, not a chip: the filled circle was pure decoration. The slot
// keeps the option icons aligned in a column, matching the native card.
export const OPTION_ICON: CSSProperties = {
  width: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: 'var(--text-secondary)',
};

export const ATTACH_ROW: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  minWidth: 0,
  padding: '4px 6px',
  borderRadius: 8,
  background: 'none',
  border: 'none',
  fontSize: 13,
  fontFamily: 'inherit',
  color: 'var(--text-secondary)',
  textAlign: 'start' as const,
};

export const ATTACH_SPINNER: CSSProperties = {
  width: 14,
  height: 14,
  flexShrink: 0,
  borderRadius: '50%',
  border: '2px solid rgba(125,124,129,0.3)',
  borderTopColor: 'var(--text-secondary)',
  animation: 'spin 0.8s linear infinite',
};

export const PARSED_ROW: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 13.5,
  color: 'var(--text-secondary)',
  padding: '8px 0',
};

export const LINK_BUTTON: CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: 'var(--text-primary)',
  fontSize: 13.5,
  fontFamily: 'inherit',
  textDecoration: 'underline',
};

export const PRIMARY_BUTTON: CSSProperties = {
  flex: 1,
  height: 48,
  borderRadius: 9999,
  border: 0,
  backgroundColor: 'var(--text-primary)',
  color: 'var(--bg)',
  fontSize: 15,
  fontWeight: 500,
  fontFamily: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  transition: 'opacity 150ms',
};

export const ERROR_TEXT: CSSProperties = {
  fontSize: 13.5,
  lineHeight: '19px',
  color: 'var(--danger, #d93025)',
  margin: 0,
};
